import React, { useState } from 'react';
import './ProjectDatabaseTable.scss';

const ProjectDatabaseTable = () => {
  const [activeFilter, setActiveFilter] = useState('Sector');

  const filters = ['Sector', 'Country', 'Investment Type', 'Impact Area', 'Financial Instrument'];

  // Sample project data
  const projects = [
    {
      id: 1,
      name: "BrightSun Initiative",
      country: "Kenya",
      sector: "Solar Energy",
      investment: "$10M",
      impact: "100,000 homes",
      status: "Active"
    },
    {
      id: 2,
      name: "Rural Electrification Project",
      country: "Uganda",
      sector: "Grid Extension",
      investment: "$5M",
      impact: "50,000 homes",
      status: "Completed"
    },
    {
      id: 3,
      name: "Clean Cookstove Initiative",
      country: "Nigeria",
      sector: "Clean Cooking",
      investment: "$2M",
      impact: "200,000 households",
      status: "Active"
    },
    {
      id: 4,
      name: "Hydro Power Development",
      country: "Rwanda",
      sector: "Renewable Energy",
      investment: "$20M",
      impact: "20,000 homes",
      status: "Active"
    },
    {
      id: 5,
      name: "Wind Energy Project",
      country: "Ethiopia",
      sector: "Wind Energy",
      investment: "$15M",
      impact: "150,000 homes",
      status: "Completed"
    },
    {
      id: 6,
      name: "Off-Grid Solar Solutions",
      country: "Tanzania",
      sector: "Solar Energy",
      investment: "$8M",
      impact: "80,000 homes",
      status: "Active"
    },
    {
      id: 7,
      name: "Biogas Initiative",
      country: "Ghana",
      sector: "Bioenergy",
      investment: "$3M",
      impact: "300,000 households",
      status: "Completed"
    },
    {
      id: 8,
      name: "Energy Efficiency Program",
      country: "South Africa",
      sector: "Energy Efficiency",
      investment: "$7M",
      impact: "70,000 homes",
      status: "Active"
    },
    {
      id: 9,
      name: "Geothermal Energy Exploration",
      country: "Zambia",
      sector: "Geothermal Energy",
      investment: "$12M",
      impact: "120,000 homes",
      status: "Completed"
    },
    {
      id: 10,
      name: "Hybrid Renewable Systems",
      country: "Mozambique",
      sector: "Hybrid Energy",
      investment: "$6M",
      impact: "60,000 homes",
      status: "Active"
    }
  ];

  const getStatusClass = (status) => {
    return status === 'Active' ? 'status-active' : 'status-completed';
  };

  return (
    <div className="project-database-table">
      <div className="section-header">
        <h3 className="section-title">Project Database</h3>
        <p className="section-subtitle">Detailed information on energy projects</p>
      </div>
      
      <div className="table-filters">
        {filters.map(filter => (
          <button
            key={filter}
            className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>
      
      <div className="table-container">
        <table className="projects-table">
          <thead>
            <tr>
              <th>Project Name</th>
              <th>Country</th>
              <th>Sector</th>
              <th>Investment Amount</th>
              <th>Impact</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {projects.map(project => (
              <tr key={project.id}>
                <td className="project-name">{project.name}</td>
                <td className="country">{project.country}</td>
                <td className="sector">{project.sector}</td>
                <td className="investment">{project.investment}</td>
                <td className="impact">{project.impact}</td>
                <td className="status">
                  <span className={`status-badge ${getStatusClass(project.status)}`}>
                    {project.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectDatabaseTable;
